import Vue from 'vue';
import _debounce from 'lodash/debounce';

export const EventBus = new Vue({
    data() {
        return {
            pageLoaded: false,
            altLogo: false,
            numberOfModules: 0,
            imageCount: 0,
            navOpen: false,
            pageContent: '',
            showSubmenu: false
        };
    },
    methods: {
        resetImageCount() {
            this.imageCount = 0;
        },
        addImage() {
            this.imageCount++;

            if (!this._imageLoadedTimeout) {
                this._imageLoadedTimeout = _debounce(this.allImagesLoaded, 5000);
            }
            this._imageLoadedTimeout();
        },
        imageLoaded() {
            this.imageCount = Math.max(this.imageCount - 1, 0);

            if (this.imageCount === 0) {
                this.allImagesLoaded();
            }
        },
        allImagesLoaded() {
            this.$emit('images-loaded');
        },
        setPageLoaded(loaded) {
            this.pageLoaded = loaded;
        },
        setPageContent(pageContent) {
            this.showSubmenu = false;
            this.pageContent = pageContent;
        },
    },
});
